module.exports = "/static/assets/f5114d2193b76184f5aa2f80b063f232.png";